import { connect } from 'react-redux';
import Pricing from './Pricing';

// @ts-ignore
const mapStateToProps = ({ auth, user }) => {
  const status = user?.subscription?.status ?? null;

  return {
    isLoggedIn: auth.isLoggedIn,
    subscriptionStatus: status,
  };
};

export default connect(mapStateToProps)(Pricing);
